import { render } from "./business-resource-filters.vue?vue&type=template&id=be85825c"
import script from "./business-resource-filters.vue?vue&type=script&lang=js"
export * from "./business-resource-filters.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\MVC\\wwwroot\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__